// PeticionesContext — estado y handlers de la gestión de peticiones de canciones.
// Aislado del MainAppContext para reducir el blast-radius de bugs y permitir
// memoización efectiva.
// Creado en Feb 2026 (Fase 3 — Paso 2).
import { createContext, useContext } from "react";

export const PeticionesContext = createContext(null);

export const usePeticiones = () => {
  const ctx = useContext(PeticionesContext);
  if (ctx === null) {
    throw new Error("usePeticiones debe usarse dentro de <PeticionesContext.Provider>");
  }
  return ctx;
};
